<template lang='pug'>
  .restore-account
    .section(v-if="!responseStatus")
      .container
        .columns
          .column
            .block-center
              h2 {{ gettext('Deleted your account?') }}
              h3(v-if="!$route.query.is_social") {{ gettext('Do not worry, enter your email and we will restore it.') }}
              h3(v-else) {{ gettext('Do not worry, enter the mail that corresponds to your social network account, and we will restore it.') }}
              .field
                .field-body.has-icon
                  i.mdi.mdi-email
                  input(
                  type='email'
                  name='email'
                  v-model='form.email'
                  :placeholder="gettext('Email')"
                  @focus="displayCaptcha = true"
                  @input="$v.$touch()"
                  :class="{'is-danger': $v.form.email.$error}")
              .field
                .field-body
                  .captcha(v-show="!loading")
                    vue-recaptcha(
                    :sitekey="env.RECAPTCHA_PUBLIC_KEY"
                    @verify="captchaVerified"
                    @render="captchaReady"
                    @expired="captchaExpired" v-if="displayCaptcha")
              .loading(v-show="loading").has-text-centered
                loading(:size="'76px'")
              .field
                .field-body
                  button.main-btn.col-white.bg-red(:disabled="!formIsValid || !captchaIsValid" @click="sendForm") {{ gettext('Send') }}
    .section.thank-you(v-else)
      .container
        .columns
          .column
            .block-center(v-if="responseStatus === 'success'")
              h2 {{ gettext('Thank you!') }}
              h3 {{ gettext('A letter with instructions on restoring the account is sent to your email.') }}
              .field
                .field-body
                  router-link.main-btn.col-white.bg-red(:to="`/${getLanguage}/`") {{ gettext('Go to the main page') }}
            .block-center(v-else)
              h2 {{ gettext('Error!') }}
              h3 {{ gettext('An error occurred during the password recovery process, please contact with support or try again later.') }}
              .field
                .field-body
                  router-link.main-btn.col-white.bg-red(:to="`/${getLanguage}/`") {{ gettext('Go to the main page') }}
</template>

<script>
import Vue from 'vue'
import { gettext } from '@/services/TranslateHandler'
import { mapGetters, mapActions } from 'vuex'
import VueRecaptcha from 'vue-recaptcha'
import Vuelidate from 'vuelidate'
import { email, required } from 'vuelidate/lib/validators'
import { getEnv } from '@/services/Utils'
import Loading from '@/components/stretch-spinner'
import mixin from '@/mixins'

Vue.use(Vuelidate)

export default {
  name: 'ForgotPassword',
  mixins: [
    mixin
  ],
  components: {
    VueRecaptcha,
    Loading
  },
  data () {
    return {
      env: getEnv,
      form: {
        email: '',
        captcha: ''
      },
      captchaIsValid: false,
      responseStatus: '',
      displayCaptcha: false,
      loading: true
    }
  },
  metaInfo () {
    return this.getMetaInfoMixin({defaultMetaInfo: this.defaultMetaInfo})
  },
  validations: {
    form: {
      email: {
        email,
        required
      }
    }
  },
  methods: {
    ...mapActions([
      'restoreAccount'
    ]),
    gettext: gettext,
    captchaVerified (data) {
      this.form.captcha = data
      this.captchaIsValid = true
    },
    captchaExpired () {
      this.captchaIsValid = false
    },
    captchaReady () {
      this.loading = false
    },
    sendForm () {
      const data = {
        'email': this.form.email,
        'g-recaptcha-response': this.form.captcha
      }
      this.restoreAccount({lang: this.getLanguage, data: data, hook: 'activate-account-confirmation'}).then(res => {
        this.responseStatus = 'success'
      }).catch(() => {
        this.responseStatus = 'error'
      })
    }
  },
  computed: {
    ...mapGetters([
      'getLanguage'
    ]),
    defaultMetaInfo () {
      return {
        title: 'Bixter | ' + gettext('Restore account'),
        titleTemplate: null,
        link: [
          {rel: 'canonical', href: document.location.origin + document.location.pathname}
        ],
        script: [
          { src: 'https://www.google.com/recaptcha/api.js?onload=onloadCallback&render=explicit', async: true, defer: true }
        ]
      }
    },
    formIsValid: function () {
      return !this.$v.$invalid
    }
  },
  created () {
    document.addEventListener('capchaReady', (e) => {
      this.displayCaptcha = true
    }, false)
  }
}

window.onloadCallback = () => {
  let event = document.createEvent('Event')
  event.initEvent('capchaReady', true, true)
  document.dispatchEvent(event)
}
</script>

<style scoped lang="scss" src="./styles.scss"></style>



// WEBPACK FOOTER //
// src/pages/auth/restore-account/index.vue